import { render, staticRenderFns } from "./UseWallet.vue?vue&type=template&id=2bc4dc86&"
import script from "./UseWallet.vue?vue&type=script&lang=js&"
export * from "./UseWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports